<template>
	<div class='content'>
		<div class='banner'>
			<h3 id='about'>“共创台球”模式<br>一起畅玩</h3>
			<img :src='src' />
		</div>
		<div>
			<div class='mar' v-for='item in docs'>
				<h3>{{item.h3}}</h3>
				<p class='word'>{{item.p1}}</p>
				<p class='word'>{{item.p2}}</p>
				<p class='word'>{{item.p3}}</p>
				<p class='word'>{{item.p4}}</p>
			</div>
		</div>
	</div>
</template>
<script>
	const docs = [{
		h3: '关于xx台球厅',
		p1: '这里不仅是球技切磋的竞技场，更是休闲放松的雅致空间。我们精心打造了一个集专业与娱乐',
		p2: '于一体的台球爱好者的梦幻之地，旨在为每一位踏入这里的您，带来无与伦比的击球体验与心灵享受。',
		p4: ''
	},{
		h3: '卓越台球殿堂',
		p1: '坐拥宽敞明亮的比赛级场馆，采用国际标准的绿色台球桌，每一张都经过严格调试，',
		p2: '确保桌面的平整与弹性的完美平衡，让每一次击球都能发挥出最佳状态。柔和而聚焦的照明设计，',
		p3: '不仅减少了视觉疲劳，更让球路的预判变得清晰无误，即便是细微的旋转与反弹也能尽收眼底子',
	}];
	export default {
		name: 'shareContent',
		data () {
			return {
				src: '/static/img/about.png',
				docs: docs
			}
		}
	}
</script>
<style lang='scss'>
	#about{
		text-align: left;
		position: absolute;
		top: 16%;
		left: 20%;
		z-index: 8;
		color: white;
		font-size: 34px;
        line-height: 130%;
        animation: fadeIn 2s 0.5s ease both;
	}
	.mar{
		margin: 50px 0 50px;
		h3 {
			font-size: 36px;
			padding: 42px 0 26px;
			font-weight: 500;
			color: #666;
		}
		p {
			line-height: 32px;
			font-size: 14px;
			color: #8d8d8d;
			text-align: center;
		}
	}
</style>


// WEBPACK FOOTER //
// aboutContent.vue?7fcfe3a1